import { keepPreviousData } from "@tanstack/react-query";
import { isVirtualFolder } from "@zapier/utils";
import { RouterOutputs, trpc } from "../trpc";

interface Input {
  folderId?: string;
}

export type FolderAncestor =
  RouterOutputs["folder"]["folderAncestors"]["results"][number];

export function useQueryFolderAncestors({ folderId }: Input) {
  const { data, isLoading } = trpc.folder.folderAncestors.useQuery(
    { folderId: folderId },
    {
      enabled: !!folderId && !isVirtualFolder(folderId),
      placeholderData: keepPreviousData,
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  );
  const ancestors = data?.results || ([] as FolderAncestor[]);

  return {
    ancestors,
    isAncestorsLoading: isLoading,
  };
}
